import styled from '@emotion/styled';

export const ChatOrderFormStyle = styled.div`
  display: flex;
  flex-direction: column;

  .input-section {
    margin-bottom: 36px;

    .example{
    font-size:12px;
    font-weight: 400;
    line-height: 200%;
    color:var(--seed-scale-color-gray-600);
    margin-bottom: 8px;
  }

    .input-label {
      font-size: 18px;
      color: var(--seed-scale-color-gray-900);
      font-weight: 500;
    }

    .input-field {
      width: 100%;
      padding: 12px 14px;
      border: 1px solid var(--seed-scale-color-gray-300);
      border-radius: 8px;
      font-size: 14px;
      outline: none;
      box-sizing: border-box;

      &:focus {
        border-color: var(--seed-scale-color-gray-900);
        border-width: 2px;
      }

      &::placeholder {
        color: var(--seed-scale-color-gray-400);
      }
    }

    .price-input-wrapper {
      position: relative;
      margin-top: 16px;

      .input-field {
        padding-right: 30px;
      }

      .price-korean {
        margin-top: 4px;
        font-size: 12px;
        font-weight: 400;
        line-height: 19px;
        color: var(--seed-scale-color-gray-600);
      }
    }
  }

  

  .chip-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
  }

  .chip {
    padding: 8px 12px;
    border-radius: 25px;
    background: none;
    font-size: 12px;
    color: var(--seed-scale-color-gray-900);
    background-color: var(--seed-scale-color-gray-200);

    &.selected {
      background-color: var(--seed-scale-color-gray-900);
      color: var(--seed-scale-color-gray-100);
    }
  }

  .submit-button {
    align-self: flex-end;
    padding: 14px;
    border: none;
    border-radius: 8px;
    background-color: var(--seed-scale-color-gray-900);
    color: #ffffff;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    transition: background-color 0.15s;

    &:hover:not(:disabled) {
      background-color: var(--seed-scale-color-gray-900);
    }

    &:disabled {
      background-color: var(--seed-scale-color-gray-300);
      cursor: not-allowed;
    }
  }

  .error-message {
    color: var(--seed-static-color-red-800);
    font-size: 13px;
    margin-bottom: 12px;
    text-align: center;
  }
`;
